import { C1_DOCUMENT_LOGO } from "../../ConceptOne/src/C1_Const";

/** Loads the shared header logo once per export for reuse on every page. */
export function loadPdfDocumentLogo(source = C1_DOCUMENT_LOGO): Promise<HTMLImageElement | undefined> {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => resolve(undefined);
    image.src = source;
  });
}
